export default {
  inputKeyword: 'Enter keyword',
  selectPlease: 'Please select',
  inputBizOrderNo: 'Enter biz order no.',
  inputProductOrderNo: 'Enter product order no.',
  pieceSmartInput: 'One type per line, for example:\n120 80 60 10\n100x60x40x5',
  inputMawbNo: 'Enter MAWB no.',
  inputCustomer: 'Enter customer name',
  inputUsername: 'Enter username',
  inputPassword: 'Enter password',
  dateRange: 'Select date range',
  username: 'Username',
  password: 'Password',
  captcha: 'Captcha',
  inputCaptcha: 'Enter captcha',
  searchBizOrder: 'Search no. / customer / AWB...',
  dateStart: 'Start',
  dateEnd: 'End',
  routeExample: 'e.g. PVG-LAX',
  airlineExample: 'e.g. CA',
  fuzzySearch: 'Fuzzy search',
  selectAtd: 'Select actual departure time',
  selectAta: 'Select actual arrival time',
  searchCustomer: 'Search customer name/code',
  inputCustomerName: 'Please enter customer name',
  inputCustomerCode: 'Please enter customer code',
  // users/Index.vue placeholders
  searchUser: 'Search username or name',
  inputRealName: 'Please enter name',
  selectRole: 'Please select role',
  selectOrg: 'Please select organization',
  inputEmail: 'Please enter email',
  inputPhone: 'Please enter phone',
  // dictionary/Index.vue placeholders
  searchDictionary: 'Search dictionary name or code',
  dictCodeExample: 'e.g. cargo_type',
  dictNameExample: 'e.g. Cargo Type',
  dictNameEnExample: 'e.g. Cargo Type',
  dictDescriptionEnExample: 'e.g. Cargo type',
  itemCodeExample: 'e.g. dangerous',
  itemNameExample: 'e.g. Dangerous Goods',
  itemNameEnExample: 'e.g. Dangerous Goods',
  inputDescription: 'Please enter description',
  // agreement placeholders
  searchAgreement: 'Search agreement no. / airline',
  searchAgreementOrder: 'Search agreement entrust no.',
  searchOrCreateAgreementNo: 'Search or create agreement no. (e.g. BSA-2026-CA)',
  agreementNoExample: 'e.g. BSA-2026-Q2-CA',
  agreementEntrustNoExample: 'e.g. BSA-2026-Q2-PVG-LAX-001',
  selectAirline: 'Please select airline',
  selectAirlineOptional: 'Please select airline (optional, fill later)',
  originExample: 'e.g. PVG',
  transitPortExample: 'e.g. HKG (optional)',
  transitPortMulti: 'Separate multiple with commas',
  destinationExample: 'e.g. LAX',
  selectPalletType: 'Pallet type',
  inputCount: 'Count',
  chargeableWeightPerUldPlaceholder: 'Chargeable weight per ULD',
  volumeWeightPlaceholder: 'Volume weight quota',
  selectDate: 'Select date',
  selectAirlineOptionalHint: 'Optional, fill later',
  agreementDescriptionHint: 'Detailed description, terms, constraints, etc.',
  // system placeholders
  searchRole: 'Search role name/code...',
  searchPermission: 'Search permission...',
  searchOrg: 'Search org name/code/type...',
  searchUsername: 'Search username',
  inputRoleCode: 'Please enter role code',
  inputRoleName: 'Please enter role name',
  inputRoleNameEn: 'e.g. System Administrator',
  inputRoleDescription: 'Please enter role description',
  selectDataScope: 'Please select data scope',
  inputPermissionCodeExample: 'e.g. system:user:add',
  inputPermissionName: 'Please enter permission name',
  inputPermissionNameEn: 'e.g. Users',
  inputPermissionCode: 'Please enter permission code',
  selectParentPermission: 'Select parent (top-level if not selected)',
  inputRoutePathExample: 'e.g. /system/user',
  inputComponentPathExample: 'e.g. system/user/index',
  inputIconExample: 'e.g. User',
  selectPermissionType: 'Please select permission type',
  inputOrgCode: 'Please enter org code',
  inputOrgName: 'Please enter org name',
  inputOrgNameEn: 'e.g. Headquarters',
  inputOrgTypeHint: 'Org type (label only)',
  selectParentOrg: 'Select parent org (top-level if not selected)',
  inputOrgDescription: 'Please enter org description',
  startTime: 'Start time',
  endTime: 'End time',
  // cs-workbench placeholders
  systemOrManualInput: 'System auto-filled or manual input',
  warehouseReceiptNoOptional: 'Warehouse receipt no. (optional)',
  departurePlace: 'Departure',
  destinationPlace: 'Destination',
  viewStatus: 'View Status',
  warehouseStatus: 'Warehouse Status',
  // cs-workbench/BizOrderCreateDialog
  manualOrAutoBizOrderNo: 'Manual input or leave blank for auto-generation',
  inputCustomerNameSearch: 'Please enter customer name',
  customerCodeSystemOrManual: 'System-filled or manual input',
  inputContactName: 'Please enter contact name',
  inputContactPhone: 'Please enter contact phone',
  inputContactAddress: 'Please enter contact address',
  inputCustomerRemark: 'Please enter customer remark',
  departureExample: 'e.g. PVG',
  finalDestinationExample: 'e.g. Chicago',
  inputShippingTerms: 'Please enter shipping terms',
  inputShipperName: 'Please enter shipper name',
  inputConsigneeName: 'Please enter consignee name',
  inputCargoDescription: 'Please enter cargo description',
  inputSpecialRemark: 'Please enter special remark',
  selectDateTime: 'Select date time',
  // entry/dialogs
  selectReason: 'Select reason',
  inputDissolveReason: 'Please enter dissolve reason',
  // entry/dialogs/AddMasterAirWaybillDialog
  inputMawbNoFormat: 'Enter MAWB no., e.g. 999-12345678',
  actualFlightNoExample: 'e.g. CA981',
  selectEtd: 'Select ETD',
  selectEta: 'Select ETA',
  inputRemark: 'Please enter remark',
  // entry/dialogs/CreateProductOrderDialog
  flightNoExample: 'e.g. CA123',
  selectProductType: 'Please select product type',
  selectPleaseDash: '— Please select —',
  selectSubOrderCycle: 'Select sub agreement cycle (W1/W2... or M1/M2...)',
  inputUnitPrice: 'Please enter unit price',
  // entry/dialogs/EditProductOrderDialog
  linkAgreementOptional: 'Link Agreement (optional)',
  // entry/components
  required: 'Required',
  selectAgreementDash: '— Please select agreement —',
  // entry/components/ChangeRequestDrawer
  inputRejectReason: 'Please enter reject reason',
  // entry/components/CargoModeView
  groupMethod: 'Group by',
  searchBizOrCustomer: 'Search order/customer',
  // entry/components/RightPanel
  originPort: 'Origin',
  destinationPortShort: 'Destination',
  // entry/components/WarehouseConfirmDrawer
  selectMawbNo: 'Select MAWB No.',
  autoGeneratedEditable: 'Auto-generated, editable',
  // entry/components/LeftPanel/ProductOrderList
  searchFlightOrRouteOrNo: 'Search flight/route/no.',
  // cs-workbench/components/CenterPanel/BizOrderForm/WarehouseDataSection
  optional: 'Optional',
  // Workbench left panel ETD date range filter
  etdStart: 'ETD Start',
  etdEnd: 'ETD End',
}
